import { SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { NotificationStyle, NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';
import cookies from 'js-cookie';

var PWA_POPUP_COUNT = 'pwa-popup-count';
/**
 * The PWA Install popup creates a notification to
 * inform the user to install the PWA. You can provide
 * it with various attributes to control when the notification
 * is shown.
 *
 * By default it will only show after login, 2 times.
 */
var PWAInstallPopupComponent = /** @class */ (function (_super) {
    __extends(PWAInstallPopupComponent, _super);
    function PWAInstallPopupComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasShownThisSession = false;
        return _this;
    }
    PWAInstallPopupComponent.prototype.created = function () {
        if (!this.immediate) {
            return;
        }
        this.showNotification(true);
    };
    PWAInstallPopupComponent.prototype.showNotification = function (shouldShow) {
        var navigator = window.navigator;
        if (this.hasShownThisSession ||
            !shouldShow ||
            (navigator && navigator.standalone)) {
            return;
        }
        // Using cookies to avoid in private browsing issues on iOS.
        var popupCount = +(cookies.get(PWA_POPUP_COUNT) || 0);
        if (popupCount < this.maxShowTimes) {
            notificationService.show(this.$t('notification.pwa-install'), {
                dismissible: true,
                style: NotificationStyle.INFO,
                closeDelay: this.notificationDelay,
                uniqueID: 'notification-pwa-install',
            });
            cookies.set(PWA_POPUP_COUNT, (popupCount + 1).toString());
            this.hasShownThisSession = true;
        }
    };
    PWAInstallPopupComponent.prototype.render = function () {
        return null;
    };
    __decorate([
        Prop({
            type: Number,
            default: NotificationDelay.LONG,
        }),
        __metadata("design:type", Number)
    ], PWAInstallPopupComponent.prototype, "notificationDelay", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 2,
        }),
        __metadata("design:type", Number)
    ], PWAInstallPopupComponent.prototype, "maxShowTimes", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], PWAInstallPopupComponent.prototype, "immediate", void 0);
    __decorate([
        SessionChange(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PWAInstallPopupComponent.prototype, "showNotification", null);
    PWAInstallPopupComponent = __decorate([
        Component({
            name: 'pwa-install-popup',
        })
    ], PWAInstallPopupComponent);
    return PWAInstallPopupComponent;
}(Mixins(MagicConfigMixin)));

export default PWAInstallPopupComponent;
